import React from "react";
import { motion } from "framer-motion";
import petLogoMask from "../assets/paw-logo.svg";

// Enhanced clip-path animation with multiple refined keyframes
const waterVariants = {
  initial: { 
    clipPath: "polygon(0 100%, 100% 100%, 100% 100%, 0 100%)"
  },
  animate: {
    clipPath: [
      // 0% fill: no water
      "polygon(0 100%, 100% 100%, 100% 100%, 0 100%)",
      // 20% fill: subtle wavy top edge
      "polygon(0 100%, 100% 100%, 100% 95%, 80% 93%, 50% 92%, 20% 93%, 0 95%)",
      // 40% fill: water rising, gentle curve
      "polygon(0 100%, 100% 100%, 100% 85%, 80% 82%, 50% 80%, 20% 82%, 0 85%)",
      // 60% fill: mid fill with a more defined wave
      "polygon(0 100%, 100% 100%, 100% 70%, 80% 67%, 50% 65%, 20% 67%, 0 70%)",
      // 80% fill: high water level with pronounced wave curve
      "polygon(0 100%, 100% 100%, 100% 45%, 80% 42%, 50% 40%, 20% 42%, 0 45%)",
      // 100% fill: full water fill with top edge at container's top
      "polygon(0 100%, 100% 100%, 100% 0%, 80% 0%, 50% 0%, 20% 0%, 0 0%)"
    ],
    transition: {
      duration: 1,
      ease: "easeInOut",
      repeat: Infinity,
      repeatType: "reverse", 
    },
  },
};

const LoadingLogo = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center backdrop-blur-lg z-50">
      <div
        className="relative w-64 h-64 overflow-hidden"
        style={{
          maskImage: `url(${petLogoMask})`,
          maskSize: "contain",
          maskPosition: "center",
          maskRepeat: "no-repeat",
          WebkitMaskImage: `url(${petLogoMask})`,
          WebkitMaskSize: "contain",
          WebkitMaskPosition: "center",
          WebkitMaskRepeat: "no-repeat",
        }}
      >
        {/* Animated water fill with refined, smooth, wavy top edge */}
        <motion.div
          className="absolute inset-0 bg-gradient-to-t from-[#9A48FF] to-[#333271]"
          variants={waterVariants}
          initial="initial"
          animate="animate"
        />
      </div>
    </div>
  );
};

export default LoadingLogo;
